import { StoryType } from "@core/types";
import { BaseStoriesClient } from "../types/clients";
import { convertStoriesData } from "./converters";
import { SupaStory } from "./types";
class StoriesClient extends BaseStoriesClient {
  async getStories(): Promise<StoryType[]> {
    const response = await this.instance.get<SupaStory[]>("wp-json/wc/v3/stories");

    return response.data?.map(convertStoriesData) ?? [];
  }
}

export default StoriesClient;
